export function getUniqueFiles(acceptedFiles: File[], files: File[]) {
    return acceptedFiles.filter(
        (newFile) =>
            !files.some((existingFile) => existingFile.name === newFile.name)
    );
}
